<template>

    <CRow>
        <CCol col="12" lg="8">
            <CCard>
                <CCardHeader>
                    <strong>{{ product.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <CNav variant="tabs">
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}`">
                            Карточка
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/edit`">
                            Редактировать
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/categories`">
                            Категории
                        </CNavItem>
                        <CNavItem active>
                            Опции
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/variants`">
                            Варианты
                        </CNavItem>
                    </CNav>
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <CCol sm="4">
                            <CSelect
                                horizontal
                                :options="optionsOptions"
                                :value.sync="selectedOption"
                                placeholder="Выберите опцию..."
                            />
                        </CCol>
                        <CCol sm="8">
                            <CButton
                                color="primary"
                                class="ml-3"
                                @click="addOption">Добавить</CButton>
                        </CCol>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <thead>
                                <th>&nbsp;</th>
                                <th>Название</th>
                                <th>Вес</th>
                                <th>Цена</th>
                                <th>&nbsp;</th>
                            </thead>
                            <draggable v-model="options" tag="tbody">
                                <tr v-for="option in options" :key="option.title">
                                    <td><CIcon
                                        :height="24"
                                        :content="$options.icons.cilCursorMove"
                                        class="handle" /></td>
                                    <td>{{ option.title }}</td>
                                    <td>{{ option.weight }}</td>
                                    <td>{{ option.price }}</td>
                                    <td><CButton @click="removeOption(option.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton></td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';

    export default {

        name: 'EntityProductOptions',

        components: {
            draggable
        },

        icons: {
            cilCursorMove,
            cilTrash
        },
  
        data () {
            return {
                entity: {},
                product: {},
                options: [],
                allOptions: [],
                selectedOption: null
            }
        },
    
        computed: {
            optionsOptions: function() {
                return this.allOptions.map(option => ({
                    value: option.id,
                    label: option.title + ' - ' + option.price + ' руб. - ' + option.weight + ' гр.'
                }));
            }
        },
  
        async mounted() {
            const id = parseInt(this.$route.params.id);
            const product_id = parseInt(this.$route.params.entity_product_id);
            const code = this.$route.params.code;
            await Vue.axios.get(`/entities/get/${id}`)
                .then(resp => {
                    this.entity = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            await Vue.axios.get(`/entities/${id}/entity_products/${product_id}`)
                .then(resp => {
                    this.product = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            await Vue.axios.get(`/entities/${id}/entity_products/get-options/${product_id}`)
                .then(resp => {
                    this.options = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            await Vue.axios.get(`/entities/${code}/get-options/${id}`)
                .then(resp => {
                    this.setAllOptions(resp.data);
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {

            save() {
                const options = [];
                let index = 0;
                this.options.forEach(option => {
                    option.position = ++index;
                    options.push(option);
                });
                Vue.axios.post(`/entities/${this.entity.id}/entity_products/options/${this.product.id}`, { options })
                    .then(() => {
                        this.goBack();
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            setAllOptions(options) {
                this.allOptions = options.filter(option => !this.addOptionOption(option.id));
            },

            addOptionOption(id) {
                let contains = [...this.options].find(option => option.id === id);
                return !!contains;
            },

            addOption() {
                const selectOption = this.allOptions.find(option => option.id === this.selectedOption);
                this.options.push(selectOption);
                this.allOptions = this.allOptions.filter(option => option.id !== selectOption.id);
                this.setAllOptions(this.allOptions);
            },

            removeOption(id) {
                const removedOption = [...this.options].find(option => option.id === id);
                this.allOptions.push(removedOption);
                this.options = this.options.filter(option => option.id !== id);
                this.setAllOptions(this.allOptions);
            },

            goBack() {
                this.$router.push({ path:`/entities/${this.entity.entityType.code}/${this.entity.id}/products/${this.product.id}` })
            }
        }
    }

</script>
<style scoped>
.handle {
  cursor: pointer;
}
</style>
